/**
 * Reown AppKit Provider
 * Wraps the app with wallet connection functionality
 */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppKit } from '@reown/appkit/react';
import { WagmiProvider } from 'wagmi';
import { wagmiAdapter, projectId, networks, metadata } from '../config/reown.config';

const queryClient = new QueryClient();

// Initialize AppKit (must be called before useAppKit hooks)
if (wagmiAdapter) {
  try {
    createAppKit({
      adapters: [wagmiAdapter],
      projectId,
      networks,
      metadata,
      features: {
        analytics: false,
      },
    });
  } catch (error) {
    console.error('[AppKit] Failed to initialize:', error);
  }
}

export function AppKitProvider({ children }) {
  if (!wagmiAdapter) {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    );
  }

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default AppKitProvider;
